import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';

import { useClickTracker } from '@shared-ui/clickstream-analytics-context';

import { FilterOptionModel } from 'components/common/search-form/fields/filter-types';

import { UitkButtonToggle, UitkButtonToggleGroup } from 'uitk-react-button-toggle';
import { UitkExpandoList, UitkExpandoListItem } from 'uitk-react-expando';
import { UitkHeading } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';

const ButtonTracked = ClickTracker(UitkButtonToggle);

export const ButtonToggleExpandoList = ({
  toggleChange,
  isVisible,
  name,
  options,
  label,
  value,
}: {
  toggleChange: (Event) => void;
  isVisible: boolean;
  name: string;
  options: FilterOptionModel[];
  label: string;
  value: string;
}) => {
  const track = useClickTracker();

  return (
    <div data-stid={isVisible ? 'button-toggle-group-expando-list-visible' : 'button-toggle-group-expando-list'}>
      <UitkSpacing margin={{ blockstart: 'two' }}>
        <UitkExpandoList>
          <div className="tnl-collapsing-filter-expando-list">
            <UitkExpandoListItem
              analytics={{
                id: name,
                callback: id => {
                  const idArr = id.split('.');
                  track(`${idArr[0]}.ViewAllFilters.${idArr[1]}`, `${name}.ViewAllFilters`);
                },
              }}
              isVisible={isVisible}
              expandoTitle={
                <UitkHeading size={7} tag="h4">
                  {label}
                </UitkHeading>
              }
              expandoDescription={
                <div className="tnl-collapsing-filter-expando-button">
                  <UitkButtonToggleGroup wrapButtons={true}>
                    {options.map(
                      (option: FilterOptionModel, idx: number) =>
                        option && (
                          <ButtonTracked
                            key={`${name}-${idx}`}
                            id={`${name}-${idx}`}
                            name={name}
                            value={option.value}
                            aria-label={option.ariaLabel}
                            checked={value && value.includes(option.value)}
                            onChange={toggleChange}
                            labelText={option.label}
                            rfrr={`${name}.${option.value}`}
                            linkName={`${label} - ${option.label}`}
                          />
                        )
                    )}
                  </UitkButtonToggleGroup>
                </div>
              }
            />
          </div>
        </UitkExpandoList>
      </UitkSpacing>
    </div>
  );
};
